import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Highlight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M1.5 22H22.4998'
          stroke='currentColor'
          strokeWidth='1.4964'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.6986 12.8954L11.4903 17.7025M4.23398 18.6497L6.3495 20.4882'
          stroke='currentColor'
          strokeWidth='1.4964'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.7623 2L4.71799 14.5493C5.47482 17.3311 2.8572 21.0948 1.5603 21.9436H5.18481C7.1328 19.4449 8.40991 19.8632 10.0768 19.8632L22.4999 5.45809L18.7623 2Z'
          stroke='currentColor'
          strokeWidth='1.4964'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M1.47021 22.0282H22.47'
          stroke='currentColor'
          strokeWidth='1.4964'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.2334 1.47083C18.521 1.21381 18.9571 1.21765 19.2402 1.47961L22.9775 4.93762C23.2733 5.21133 23.2993 5.66953 23.0361 5.97473L10.6133 20.38C10.4712 20.5447 10.2644 20.6397 10.0469 20.6398C9.8244 20.6398 9.61016 20.6326 9.41309 20.6261C9.21209 20.6195 9.03031 20.6135 8.85254 20.6134C8.50059 20.6133 8.19661 20.6371 7.90039 20.7169C7.33622 20.869 6.65636 21.263 5.74512 22.4318C5.60334 22.6135 5.38483 22.7198 5.1543 22.7198H1.53027C1.19946 22.7198 0.908061 22.5027 0.813477 22.1857C0.719012 21.8687 0.843511 21.5271 1.12012 21.3458C1.61782 21.0201 2.52297 19.9921 3.21484 18.6554C3.90654 17.3189 4.27002 15.8935 3.96582 14.7745C3.89143 14.5011 3.9782 14.2085 4.18945 14.0197L18.2334 1.47083ZM4.3125 19.7628C4.01014 20.292 3.6749 20.7897 3.33301 21.2238H4.79785C4.97541 21.0103 5.14956 20.8159 5.32227 20.6407L4.3125 19.7628ZM7.69434 12.8927L11.6611 16.8732L21.4316 5.54407L18.7227 3.03821L7.69434 12.8927Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
